import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';
import TPTypography from 'components/TP-UI/TPTypography';
import TPLink from 'components/TP-UI/TPLink';

const CySecDisclaimer = ({ documents, textKey }) => {
  return (
    <TPTypography variant="body3" color="secondary">
      <Trans i18nKey={textKey} ns="auth">
        Legal: This website is operated by Fusion Markets EU Ltd, license number 444/24,
        registration number HE 434563, with registered address at 15 Spyrou Kyprianou Street, Matrix
        Tower II, 4001, Limassol, Cyprus. Risk Warning: CFDs are complex instruments and come with a
        high risk of losing money rapidly due to leverage. The vast majority of retail client
        accounts lose money when trading in CFDs. You should consider whether you understand how
        CFDs work and whether you can afford to take the high risk of losing your money. Please
        consider our
        <TPLink
          target="_blank"
          rel="noopener noreferrer"
          path={documents?.riskDisclosure || ''}
          link>
          Risk Disclosure
        </TPLink>
        Fusion Markets EU Ltd provides investment and ancillary services to residents of the
        European Union. Fusion Markets is a trading name of Fusion Markets EU Ltd. All rights
        reserved.
        <TPLink target="_blank" rel="noopener noreferrer" path={documents?.privacy || ''} link>
          Privacy Policy
        </TPLink>
        |
        <TPLink
          target="_blank"
          rel="noopener noreferrer"
          path={documents?.cookiesPolicy || ''}
          link>
          Cookie Policy
        </TPLink>
        |
        <TPLink target="_blank" rel="noopener noreferrer" path={documents?.agreement || ''} link>
          Client Agreement
        </TPLink>
      </Trans>
    </TPTypography>
  );
};

CySecDisclaimer.propTypes = {
  documents: PropTypes.object,
  textKey: PropTypes.string,
};

export default CySecDisclaimer;
